<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5 10H7C9 10 10 9 10 7V5C10 3 9 2 7 2H5C3 2 2 3 2 5V7C2 9 3 10 5 10Z" stroke="url(#paint0_linear_3924_7620)" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M17 10H19C21 10 22 9 22 7V5C22 3 21 2 19 2H17C15 2 14 3 14 5V7C14 9 15 10 17 10Z" stroke="url(#paint1_linear_3924_7620)" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M17 22H19C21 22 22 21 22 19V17C22 15 21 14 19 14H17C15 14 14 15 14 17V19C14 21 15 22 17 22Z" stroke="url(#paint2_linear_3924_7620)" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M5 22H7C9 22 10 21 10 19V17C10 15 9 14 7 14H5C3 14 2 15 2 17V19C2 21 3 22 5 22Z" stroke="url(#paint3_linear_3924_7620)" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    <defs>
      <linearGradient id="paint0_linear_3924_7620" x1="11.6724" y1="-7.50314" x2="18.0909" y2="7.51362" gradientUnits="userSpaceOnUse">
        <stop stop-color="#6782F6"/>
        <stop offset="1" stop-color="#41DEBD"/>
      </linearGradient>
      <linearGradient id="paint1_linear_3924_7620" x1="23.6724" y1="-7.50314" x2="30.0909" y2="7.51362" gradientUnits="userSpaceOnUse">
        <stop stop-color="#6782F6"/>
        <stop offset="1" stop-color="#41DEBD"/>
      </linearGradient>
      <linearGradient id="paint2_linear_3924_7620" x1="23.6724" y1="4.49686" x2="30.0909" y2="19.5136" gradientUnits="userSpaceOnUse">
        <stop stop-color="#6782F6"/>
        <stop offset="1" stop-color="#41DEBD"/>
      </linearGradient>
      <linearGradient id="paint3_linear_3924_7620" x1="11.6724" y1="4.49686" x2="18.0909" y2="19.5136" gradientUnits="userSpaceOnUse">
        <stop stop-color="#6782F6"/>
        <stop offset="1" stop-color="#41DEBD"/>
      </linearGradient>
    </defs>
  </svg>
</template>